import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { registerUser, updateDoctorDetails, updateUserDetais } from "../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate } from "../../utils/utils";
import { updateDoctorData, updateUserData } from "../../store/appSlice";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";

export default function DoctorProfileSetup() {
  pageTitle("Complete Profile Registration");

  const [loading, setLoading] = useState(false);
  const doctorData = useSelector((state) => state.appSlice.doctorData);
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState("IN");
  const [gender, setGender] = useState(1);
  const [mobile, setMobile] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (doctorData?.mobile_number) {
      navigate("/doctor-profile");
    }
  }, [doctorData, navigate]);

  const mapCountries = countries.map((it) => ({ label: it.country_name, value: it.phone_code }));

  const onSelectCountryItem = (c) => {
    setSelectedCountry(c);
  };
  const handleSubmitClick = async () => {
    if (mobile === "") {
      toast.error("Mobile number is required");
      return;
    }
    if (!selectedCountry) {
      toast.error("Country is required");
      return;
    }

    if (mobile != "" && mobile.length < 8) {
      toast.error("Invalid mobile number");
      return;
    }
    const payload = {
      doctor_id: doctorData?.id,
      identity: doctorData?.identity,
      mobile_number: `${mobile} ${selectedPhoneCountry}`,
      country_code: selectedCountry,
      gender: gender,
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(updateDoctorDetails, {
        ...payload,
      });
      if (response.data?.status) {
        toast.success("Doctor details has been updated.");
        dispatch(updateDoctorData(response?.data?.data));
        navigate("/doctor-profile");
      } else {
        toast.error(response.data?.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Section topMd={60} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center mx-auto">
          <div className="col-12 col-md-4 g-2 mx-auto">
            <CommonMobileHeader canBack={true} title={"Complete Profile"} />
            <p className="fs-md text-grey2 p-2"></p>
            <MobileNumberWithCountryCode selectedPhoneCountry={selectedPhoneCountry} onChange={setSelectedPhoneCountry} mobile={mobile} onMobileChange={setMobile} />
            <SelectField2 defaultValue={selectedCountry} label={"Select Country"} placeholder={"Select a country"} items={mapCountries} onChange={onSelectCountryItem} />
            <SelectField
              defaultValue={gender}
              label={"Select Gender"}
              items={[
                { label: "Male", value: 1 },
                { label: "Female", value: 0 },
              ]}
              onChange={(e) => setGender(e.target.value)}
            />
            <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={loading} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
